export const TestIds = {
  root: 'imageX',
  scrollEffectStyle: 'scrollEffectStyle',
};

export const COMP_SELECTOR_PLACEHOLDER = '#<%= compId %>';
